import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-647049ec"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "flex furnaceNumber"
};
var _hoisted_2 = {
  class: "input-item mgt1 mgl3"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "pdr1"
  }, "炉号: ", -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "pdr1 mgl3"
  }, "产品编号: ", -1);
});

var _hoisted_5 = {
  class: "input-item mgt1 mgl3"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "pdr1"
  }, "浇注日期: ", -1);
});

var _hoisted_7 = {
  class: "btn mgt1 mgl2"
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode("查询");

var _hoisted_9 = /*#__PURE__*/_createTextVNode("重置");

var _hoisted_10 = {
  class: "btn-box mgl2 mgt2"
};

var _hoisted_11 = /*#__PURE__*/_createTextVNode("生成探伤报告");

var _hoisted_12 = /*#__PURE__*/_createTextVNode("生成探伤记录");

var _hoisted_13 = /*#__PURE__*/_createTextVNode("查看详情");

var _hoisted_14 = /*#__PURE__*/_createTextVNode("查看详情");

var _hoisted_15 = /*#__PURE__*/_createTextVNode("查看详情");

var _hoisted_16 = /*#__PURE__*/_createTextVNode("查看详情");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");

  var _component_el_date_picker = _resolveComponent("el-date-picker");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_divider = _resolveComponent("el-divider");

  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_table = _resolveComponent("el-table");

  var _component_FurnaceOperation = _resolveComponent("FurnaceOperation");

  var _component_Composition = _resolveComponent("Composition");

  var _component_Mechanics = _resolveComponent("Mechanics");

  var _component_Metalloscope = _resolveComponent("Metalloscope");

  var _component_Scrap = _resolveComponent("Scrap");

  var _component_el_card = _resolveComponent("el-card");

  return _openBlock(), _createBlock(_component_el_card, {
    class: "furnaceNumberManage w35"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_input, {
        modelValue: $data.model.sId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return $data.model.sId = $event;
        }),
        class: "w200"
      }, null, 8, ["modelValue"]), _hoisted_4, _createVNode(_component_el_input, {
        modelValue: $data.model.productNumber,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return $data.model.productNumber = $event;
        }),
        class: "w200"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_date_picker, {
        modelValue: $data.areaDate,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return $data.areaDate = $event;
        }),
        type: "daterange",
        "range-separator": "—",
        "start-placeholder": "开始时间",
        "end-placeholder": "结束时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
        onClick: $options.query
      }, {
        default: _withCtx(function () {
          return [_hoisted_8];
        }),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        onClick: $options.resetForm
      }, {
        default: _withCtx(function () {
          return [_hoisted_9];
        }),
        _: 1
      }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
        type: "success"
      }, {
        default: _withCtx(function () {
          return [_hoisted_11];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        color: "#3271ae",
        type: "info"
      }, {
        default: _withCtx(function () {
          return [_hoisted_12];
        }),
        _: 1
      })]), _createVNode(_component_el_divider), _createVNode(_component_el_table, {
        "max-height": "600",
        border: "",
        class: "mgt3",
        data: $data.tableData,
        style: {
          "width": "100%"
        },
        "highlight-current-row": "",
        onCurrentChange: $options.handleCurrentChange
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            type: "index",
            align: "center",
            prop: "序号"
          }), _createVNode(_component_el_table_column, {
            "header-align": "center",
            align: "center",
            prop: "sId",
            label: "炉号"
          }, {
            default: _withCtx(function (_ref) {
              var row = _ref.row;
              return [_createTextVNode(_toDisplayString($options.fillFurnace(row.sId)), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            "header-align": "center",
            align: "center",
            prop: "product",
            label: "产品名称",
            "min-width": "100px"
          }), _createVNode(_component_el_table_column, {
            "header-align": "center",
            align: "center",
            prop: "endNumber",
            label: "产品编号",
            "min-width": "130px"
          }, {
            default: _withCtx(function (_ref2) {
              var row = _ref2.row;
              return [_createTextVNode(_toDisplayString($options.productNumber(row)), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            "header-align": "center",
            align: "center",
            prop: "pourDate",
            label: "浇注日期",
            width: "160px"
          }, {
            default: _withCtx(function (_ref3) {
              var row = _ref3.row;
              return [_createTextVNode(_toDisplayString($options.formattDate(row)), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            "header-align": "center",
            "min-width": "90px",
            align: "center",
            label: "化学成分"
          }, {
            default: _withCtx(function (_ref4) {
              var row = _ref4.row;
              return [_createVNode(_component_el_button, {
                onClick: function onClick($event) {
                  return $options.toViewChemicalComposition(row);
                },
                type: "text"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_13];
                }),
                _: 2
              }, 1032, ["onClick"])];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            "header-align": "center",
            "min-width": "90px",
            align: "center",
            label: "力学性能"
          }, {
            default: _withCtx(function (_ref5) {
              var row = _ref5.row;
              return [_createVNode(_component_el_button, {
                onClick: function onClick($event) {
                  return $options.viewMechanicalProperty(row);
                },
                type: "text"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_14];
                }),
                _: 2
              }, 1032, ["onClick"])];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            "header-align": "center",
            "min-width": "90px",
            align: "center",
            label: "金相结果"
          }, {
            default: _withCtx(function (_ref6) {
              var row = _ref6.row;
              return [_createVNode(_component_el_button, {
                onClick: function onClick($event) {
                  return $options.editmetal(row);
                },
                type: "text"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_15];
                }),
                _: 2
              }, 1032, ["onClick"])];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            "header-align": "center",
            "min-width": "90px",
            align: "center",
            label: "探伤结果"
          }, {
            default: _withCtx(function (_ref7) {
              var row = _ref7.row;
              return [_createVNode(_component_el_button, {
                onClick: function onClick($event) {
                  return $options.viewInspection(row);
                },
                type: "text"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_16];
                }),
                _: 2
              }, 1032, ["onClick"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["data", "onCurrentChange"]), _createVNode(_component_FurnaceOperation, {
        onGetFurnaceList: $options.getFurnaceNo,
        productlist: $data.productlist,
        MaterialList: $data.MaterialList,
        ref: "furnaceOperation"
      }, null, 8, ["onGetFurnaceList", "productlist", "MaterialList"]), _createVNode(_component_Composition, {
        ref: "composition"
      }, null, 512), _createVNode(_component_Mechanics, {
        ref: "mechanics"
      }, null, 512), _createVNode(_component_Metalloscope, {
        ref: "metalloscope"
      }, null, 512), _createVNode(_component_Scrap, {
        ref: "scrap"
      }, null, 512)];
    }),
    _: 1
  });
}